import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { 
  HomeOutlined, 
  PictureOutlined, 
  ToolOutlined,
  GithubOutlined
} from '@ant-design/icons';

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  
  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <Header style={{ 
        display: 'flex', 
        alignItems: 'center',
        padding: '0 20px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          marginRight: '30px'
        }}>
          <Title level={3} style={{ margin: 0 }}>工具集</Title>
        </div>
        <Menu 
          mode="horizontal" 
          selectedKeys={[location.pathname]}
          style={{ flex: 1, border: 'none' }}
        >
          <Menu.Item key="/" icon={<HomeOutlined />}>
            <Link to="/">首页</Link>
          </Menu.Item>
          <Menu.Item key="/image-processor" icon={<PictureOutlined />}>
            <Link to="/image-processor">图片处理</Link>
          </Menu.Item>
          <Menu.Item key="/placeholder" icon={<ToolOutlined />}>
            <Link to="/placeholder">更多工具</Link>
          </Menu.Item>
        </Menu>
      </Header>
      <Content style={{ padding: '24px 50px', backgroundColor: '#f5f5f5' }}>
        <div style={{ 
          background: '#fff', 
          padding: 24, 
          minHeight: 280,
          borderRadius: '4px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          {children}
        </div>
      </Content>
      <Footer style={{ textAlign: 'center', backgroundColor: '#fff' }}>
        <div style={{ marginBottom: '10px' }}>
          工具集 ©{new Date().getFullYear()} 使用 React + Ant Design 创建
        </div>
        <div>
          <a 
            href="https://github.com" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: 'rgba(0,0,0,0.45)' }}
          >
            <GithubOutlined style={{ fontSize: '16px', marginRight: '5px' }} />
            GitHub
          </a>
        </div>
      </Footer>
    </Layout>
  );
};

export default MainLayout;